<template>
  <div 
    :id="$attrs._id"
    class="tag-box"
    :class="{ 
      'tag-box--easty': directionIsEasty,
      'tag-box--southy': directionIsSouthy
    }"
    :style="styles"
  >
    <div class="tag-box__arrow-col">
      <fa :style="arrowStyle" :icon="'arrow-up'" />
    </div>
    <div class="tag-box__content-col" :dir="language.dir">
      <div class="tag-box__label" v-html="label[language.code]"></div>
      <div class="tag-box__distance"><fa class="tag-box__car" :icon="['fad', faIcon]"/><span v-html="distance[language.code]"></span></div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['pos', 'label', 'distance', 'arrowDeg', 'icon', 'background-colour', 'text-colour'],
 
  computed: {
    arrowStyle () {
      return { transform: `rotate(${this.arrowDeg}deg)` }
    },

    directionIsEasty () {
      return this.arrowDeg > 0 && this.arrowDeg < 180
    },

    directionIsSouthy () {
      return this.arrowDeg > 90 && this.arrowDeg < 270
    },

    faIcon () {
      return this.icon || 'car'
    },

    language () {
      return this.$store.getters.language
    },

    styles () {
      const style = {
        left: `${(this.pos.x / 20) / 1.3}em`,
        top: `${(this.pos.y / 20) / 1.3}em`,
      }

      // feed per-tag colours into CSS vars, if present
      if (this.backgroundColour) {
        style['--tag-box-bg-color'] = this.backgroundColour
      }
      if (this.textColour) {
        style['--tag-box-font-color'] = this.textColour
      }

      return style
    }
  },
}
</script>
<style lang="scss" scoped>
.tag-box {
  background-color: var(--tag-box-bg-color);
  border-radius: var(--border-radius-sm);
  box-shadow: var(--tag-box-shadow);
  color: var(--tag-box-font-color);
  display: flex;
  font-size: 1.3em;
  letter-spacing: .05em;
  line-height: 1.2em;
  opacity: 0;
  padding: 1em 0.5em;  
  position: absolute;
  transform: translateY(1rem);
  z-index: var(--tag-z-index);

  &.enter {
    opacity: 1;
    transform: translateY(0);
    transition: opacity 1.2s, transform 0.6s;
  }

  * {
    pointer-events: none;
    user-select: none;
  }

  &--easty {
    flex-direction: row-reverse;

    .tag-box__content-col {
    }
  }

  &--southy {
    .tag-box__arrow-col {
      align-items: flex-end;
    }
  }

  &__arrow-col {
    display: flex;
    flex-shrink: 0;
    padding: 0;
    width: calc(3em / 1.3);
    justify-content: center;
  }

  &__content-col {
    display: flex;
    flex-direction: column;
    padding: 0 calc(0.5em / 1.3);
  }

  &__label {
    margin-bottom: 0.6em;
  }

  &__distance {
    text-wrap-mode: nowrap;
  }

  &__car {
    margin-right: 0.6em;
  }
}
</style>
